import { pluralizeByUnit } from '@sravni/utils/lib/pluralize';
import { TERMS } from '../../constants/termsAndDuration.js';
import { getAmountRangeToString, getHumanizedMinValue } from '../../helpers/humanization.js';

const getHealthInsuranceTerms = item => {
    const conditions = [];
    // возраст, страховая сумма, цена
    // возраст
    const { ageMin, ageMax } = item;
    const ageValue = getAmountRangeToString({
        amountRange: {
            from: ageMin,
            to: ageMax,
        },
        isFloat: false,
        prefix: false,
        allowZero: true,
        defaultText: 'Любой',
    });
    conditions.push({
        value: `${ageValue} ${pluralizeByUnit(ageMax || ageMin, TERMS.year)}`,
        description: 'Возраст',
        key: 'age',
    });
    // страховая сумма
    const { sumAll, sumAllTo } = item;
    const sumValue = getHumanizedMinValue({ from: sumAll, to: sumAllTo, isConvert: true }, ' ₽', 'Без ограничений');
    conditions.push({
        value: sumValue,
        description: 'Страховая сумма',
        key: 'sum',
    });
    // цена
    const { price, priceTo } = item;
    const priceValue = getHumanizedMinValue({
        from: price,
        to: priceTo,
        isFloat: false,
    }, ' ₽ в год', '\u2014');
    conditions.push({ value: priceValue, description: 'Цена', wide: true, key: 'price' });
    return conditions;
};

export { getHealthInsuranceTerms };
//# sourceMappingURL=healthInsurance.js.map
